import { Space, SpaceProps } from 'component/Space'
import { ForwardedRef, forwardRef } from 'react'

export const Vertical = forwardRef((props: SpaceProps, ref: ForwardedRef<HTMLDivElement>) => {
  return <Space ref={ref} vertical {...props} />
})
